import {Coolant} from './coolantTypes';
import {Device, DeviceMetaData} from './device';
import {HeatSource} from './heatSource';
import {HeatSystem} from './heatSystems';
import {InstallationTypeCode} from './installationType';

export type RegistrationRevision = {
  registrationDtoRevision?: string;
}

export type Customer = {
    firstName?: string;
    lastName?: string;
    address?: string;
    zipCode?: string;
    city?: string;
    phone?: string;
    email?: string;
    type?: string;
    insuranceType?: string;
    country?: string;
};

export type CustomerUpdate = Customer & RegistrationRevision;

export type Location = {
    propertyType?: string;
    installationAddress?: string;
    zipCode?: string;
    city?: string;
    installationDate?: string;
    country?: string;
}

export type LocationUpdate = Location & RegistrationRevision;

export type HeatingSetup = {
    heatSource?: Array<HeatSource['code']>;
    heatSystem?: Array<HeatSystem['code']>;
    coolant?: Coolant['code'];
    installationType?: InstallationTypeCode;
    comment?: string;
}

export type HeatingSetupUpdate = HeatingSetup & RegistrationRevision;

export type Devices = {
    items: Device[];
}

export type DeviceUpdate = RegistrationRevision & {
    deviceIds: string[];
}

export type Registration = {
    id: string;
    partnerId: string;
    updated?: string;
    status?: string;
    market?: string;
    customer?: Customer;
    location?: Location;
    heatingSetup?: HeatingSetup;
    devices?: Devices;
    revision?: string;
    conflict?: Registration | DeviceConflict;
    conflictType?: RegistrationConflictType;
    canBeUnlocked?: boolean;
};

export type DeviceConflict = string[];

export enum RegistrationConflictType {
    registration = "registration",
    device = "device",
}

export type RegistrationMetaData = {
    id: string;
    partnerId: string;
    updated?: string;
    status?: string;
    installationDate?: string;
    installationAddress?: string;
    endCustomerFullName?: string;
    devices?: DevicesMetaData;
    revision?: string;
};

export type DevicesMetaData = {
    items: DeviceMetaData[];
}

export type RegistrationMisc = {
    hasConflict?: boolean;
    isSynced?: boolean;
    mainId?: string;
};

export type RegistrationDTO = Registration & RegistrationMisc;

export enum RegistrationStatusCode {
    Updated = "UPDATED",
    Completed = "COMPLETED",
}

export type PartnerInfo = {
    id: string;
    customerId: string;
    companyName: string;
    partnerLevel: string;
    salesArea?: {
        market?: string;
        region?: string;
    };
};